import { Box } from '@optiaxiom/react';

type UnreadIndicatorCellProps = {
  isRead: boolean;
};

/**
 * Renders a box of fixed size so the checkbox column stays aligned across rows,
 * regardless of read state. The dot is only visible for unread notifications.
 */
export function UnreadIndicatorCell({ isRead }: UnreadIndicatorCellProps) {
  return (
    <Box
      rounded="full"
      bg={isRead ? 'transparent' : 'bg.error'}
      size="10"
      flex="none"
      alignSelf="center"
    />
  );
}
